import {Layout, Tabs, Card} from 'antd';
import appColors from '../../style/theme';
import EntrepreneurshipLogic from './EntrepreneurshipLogic';
import EntrepreneurshipCS from './EntrepreneurshipCS';
import EntrepreneurshipBM from './EntrepreneurshipBM';
import EntrepreneurshipPD from './EntrepreneurshipPD';
import EntrepreneurshipM from './EntrepreneurshipM';
import EntrepreneurshipFF from './EntrepreneurshipFF';
import React from 'react';
import {DollarCircleOutlined, EditOutlined, EyeOutlined, FormOutlined, FundProjectionScreenOutlined, TeamOutlined} from '@ant-design/icons';
import {useState} from 'react';
const {Content} = Layout;

const EntrepreneurshipPage = () => {
  const [TAUno, setTAUno] = useState(appColors['ColorA']);
  const [GAUno, setGAUno] = useState('white');
  // others
  const [TUno, setTUno] = useState('transparent');
  const [GUno, setGUno] = useState(appColors['ColorB']);
  const [Tno, setTno] = useState('transparent');
  const [Gno, setGno] = useState(appColors['ColorC']);
  const [To, setTo] = useState('transparent');
  const [Go, setGo] = useState(appColors['ColorD']);
  const [ToI, setToI] = useState('transparent');
  const [GoI, setGoI] = useState(appColors['ColorE']);
  const [ToII, setToII] = useState('transparent');
  const [GoII, setGoII] = useState(appColors['ColorF']);
  const changeColor1 = (key) => {
    if (key === 'one') {
      setTAUno(appColors['ColorA']);
      setGAUno('white');
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'two') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno(appColors['ColorB']);
      setGUno('white');
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'three') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno(appColors['ColorC']);
      setGno('white');
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'four') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo(appColors['ColorD']);
      setGo('white');
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'five') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI(appColors['ColorE']);
      setGoI('white');
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'six') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII(appColors['ColorF']);
      setGoII('white');
    }
  };
  const items_ = [
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: TAUno,
        marginLeft: '3vh',
      }}
      cover={
        <EyeOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GAUno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', fontSize: '2vh', marginTop: '-4vh', color: GAUno}}><b>Overview</b></p>
    </Card>, key: 'one', children: <EntrepreneurshipLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: TUno,
        marginLeft: '3vh',
      }}
      cover={
        <TeamOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GUno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', fontSize: '2vh', marginTop: '-4vh', color: GUno}}><b>Customers<br/>and Stakeholders</b></p>
    </Card>, key: 'two', children: <EntrepreneurshipCS/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: Tno,
        marginLeft: '3vh',
      }}
      cover={
        <FormOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: Gno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: Gno}}><b>Business<br/>Model</b></p>
    </Card>, key: 'three', children: <EntrepreneurshipBM/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: To,
        marginLeft: '3vh',
      }}
      cover={
        <EditOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: Go}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: Go}}><b>Product<br/>Design</b></p>
    </Card>, key: 'four', children: <EntrepreneurshipPD/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: ToI,
        marginLeft: '3vh',
      }}
      cover={
        <FundProjectionScreenOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GoI}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '3vh', marginTop: '-4vh', color: GoI}}><b>Marketing</b></p>
    </Card>, key: 'five', children: <EntrepreneurshipM/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: ToII,
        marginLeft: '3vh',
      }}
      cover={
        <DollarCircleOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GoII}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-3vh', color: GoII}}><b>Financial and<br/>Fundraising</b></p>
    </Card>, key: 'six', children: <EntrepreneurshipFF/>},
  ];
  return (
    <Layout style={{background: 'transparent'}}>
      <Content style={{padding: '24px', background: 'transparent'}}>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="line"
          items={items_}
          size='small'
          onTabClick={changeColor1}
          tabBarGutter='-1vh'
        />
      </Content>
    </Layout>
  );
};

export default EntrepreneurshipPage;
